import { Col, Row } from 'react-bootstrap';
import { length } from 'redux-form-validators';
import React from 'react';
import CalculatedPremium from '../CalculatedPremium/CalculatedPremium';
import InputError from '../../../InputError/InputError';
import './CalculatedPremiumsField.scss';

const CalculatedPremiumsField = ({
  input,
  meta,
  calculatedPremiums,
  selectedSchemes,
  definitions,
  numTravellers,
  isCalculating,
}) => {
  const toggleSchemeSelect = (schemeId) => {
    // toggleSchemeSelect(premium.scheme.id);
    input.onChange([
      {
        id: schemeId,
      },
    ]);
  };

  return (
    <div className={'calculated-premiums-field'}>
      <Row>
        <Col sm={12}>
          {calculatedPremiums.map((calculatedPremium) => {
            const schemeId = calculatedPremium.meta.scheme.id;
            const isSelected = !!selectedSchemes?.find(
              (scheme) => scheme.id === schemeId,
            );
            const hasSchemesSelected = selectedSchemes && !!selectedSchemes.length;
            return (
              <>
                <CalculatedPremium
                  name={'data.relationships.schemes.data'}
                  component={CalculatedPremium}
                  premium={calculatedPremium?.meta}
                  isSelected={isSelected}
                  hasSchemesSelected={hasSchemesSelected}
                  definitions={definitions}
                  numTravellers={numTravellers}
                  validate={length({ is: 1, msg: 'Please select at least one scheme' })}
                  toggleSchemeSelect={toggleSchemeSelect}
                  isCalculating={isCalculating}
                />
              </>
            );
          })}
        </Col>
      </Row>

      <InputError meta={meta} />
    </div>
  );
};

export default CalculatedPremiumsField;
